import React from 'react';
import Type from 'prop-types';
import {
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Checkbox,
  IconButton,
} from "@mui/material";
import { Done as DoneIcon } from "@mui/icons-material";

const FilterItem = (props) => {
  const { item, isMulti, isSelected, onToggle } = props;

  const handleToggle = () => {
    onToggle(item);
  };

  const renderSecondaryActionItem = () => {
    if (isMulti) {
      return (
        <Checkbox
          color="primary"
          edge="end"
          onChange={handleToggle}
          checked={isSelected}
          inputProps={{ 'aria-labelledby': item.id }}
        />
      );
    }

    return (
      isSelected && (
        <IconButton>
          <DoneIcon />
        </IconButton>
      )
    );
  };

  return (
    <ListItem onClick={handleToggle} button data-testid="filterPopupItem">
      <ListItemText id={item.id} primary={item.name} />
      <ListItemSecondaryAction>{renderSecondaryActionItem()}</ListItemSecondaryAction>
    </ListItem>
  );
};

FilterItem.propTypes = {
  isSelected: Type.bool.isRequired,
  item: Type.shape({
    id: Type.string.isRequired,
    name: Type.string.isRequired,
  }).isRequired,
  isMulti: Type.bool,
  onToggle: Type.func.isRequired,
};

FilterItem.defaultProps = {
  isMulti: false,
};

export default FilterItem;
